import { Dialog, DialogActions, DialogContent, DialogTitle } from "@mui/material";
import React from "react";

const DialogsWrapper = ({
    open,
    onClose,
    message,
    children,
    ...props
}) => {

    return (
        open ? 
        <Dialog 
            open={open} 
            onClose={onClose} 
            {...props} 
            sx={{
                ".MuiDialog-paper": {
                    background: "var(--bg-card-primary)",
                    color: "var(--text-primary)",
                }
            }}>
            <DialogTitle>{children}</DialogTitle>
        </Dialog> : null
    );
};

export default DialogsWrapper;